var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "social-login-btns" }, [
      !_vm.isLoading
        ? _c("div", [
            _vm.showAgreementText
              ? _c("div", { staticClass: "agreement" }, [
                  _c("input", {
                    attrs: { type: "checkbox" },
                    on: {
                      click: function ($event) {
                        _vm.isChecked = !_vm.isChecked
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _vm.showError
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v("You must agree to continue"),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "button button-fb",
                on: {
                  click: function ($event) {
                    return _vm.authenticate("Facebook")
                  },
                },
              },
              [
                _c("i", { staticClass: "fab fa-facebook-f" }),
                _vm._v(" Continue With Facebook\n            "),
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "button button-google",
                on: {
                  click: function ($event) {
                    return _vm.authenticate("Google")
                  },
                },
              },
              [
                _c("i", { staticClass: "fab fa-google" }),
                _vm._v(" Continue With Google\n            "),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading
        ? _c("div", { staticClass: "social-login-loading" }, [
            _c("i", { staticClass: "fas fa-spinner fa-spin fa-3x" }),
            _c("br"),
            _vm._v(
              "\n            Logging you in with " +
                _vm._s(_vm.loginMethod) +
                ". Please wait...\n        "
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("I have read and agree to the "),
      _c("a", { attrs: { href: "/tos", target: "_blank" } }, [
        _vm._v("terms of service"),
      ]),
      _vm._v(" & "),
      _c("a", { attrs: { href: "/privacy", target: "_blank" } }, [
        _vm._v("privacy policy"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }